import { Text } from "common/text"
import styled from 'styled-components'
import { useCreateTeacherForm } from "../../hook/useCreateTeacherForm"
import ReactImageFallback from "react-image-fallback"

export const IdentityBack = () => {
    const {identityBack} = useCreateTeacherForm()
    const {methods} = identityBack

    return (
        <StyleIdentityBack>
            <Text>Mặt sau CCCD</Text>
            <div className="wrapper-identity">
                {identityBack?.value && (
                    <div>
                        <ReactImageFallback
                            src={identityBack?.value}
                            alt={'identity'}
                            style={{width: 280, height: 'auto'}}
                        />
                    </div>
                )}
                <div className="wrapper-update-picture">
                    <input 
                        title="" type='file' accept="image/png, image/jpeg"
                        onChange={e => methods.onUploadBack(e, 'indentity_back')}
                        className='identity-upload-image'
                    />
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.46863 1.37598H6.53113C6.44779 1.37598 6.40613 1.41764 6.40613 1.50098V6.40723H1.75024C1.66691 6.40723 1.62524 6.44889 1.62524 6.53223V7.46973C1.62524 7.55306 1.66691 7.59473 1.75024 7.59473H6.40613V12.501C6.40613 12.5843 6.44779 12.626 6.53113 12.626H7.46863C7.55196 12.626 7.59363 12.5843 7.59363 12.501V7.59473H12.2502C12.3336 7.59473 12.3752 7.55306 12.3752 7.46973V6.53223C12.3752 6.44889 12.3336 6.40723 12.2502 6.40723H7.59363V1.50098C7.59363 1.41764 7.55196 1.37598 7.46863 1.37598Z" fill="black" fillOpacity="0.85"/>
                    </svg>
                    <Text color="#3264FF">Tải ảnh</Text>
                </div>
            </div>
        </StyleIdentityBack>
    )
}

const StyleIdentityBack = styled.div`
    .wrapper-identity {
        margin-top: 8px;
        display: flex;
        gap: 16px;
    }
    .wrapper-update-picture {
        position: relative;
        width: 104px;
        height: 104px;
        opacity: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 8px;
        border-radius: 2px;
        border-width: 1px;
        border-style: dashed;
        border-color: #D9D9D9;
        background: #FAFAFA;
        cursor: pointer;
    }
    .identity-upload-image {
        width: 100%;
        height: 100%;
        opacity: 0;
        position: absolute;
        cursor: pointer;
    }
`